export default function ownerDocument(node) {
  return node && node.ownerDocument || document;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-overlays/node_modules/dom-helpers/esm/ownerDocument.js
// module id = 512
// module chunks = 29